import React, {useEffect, useState, useRef} from 'react';
import $ from 'jquery';

import {Link, navigate} from 'gatsby';
import { Container, Row, Col } from "react-bootstrap"

import "../scss/static_page.scss";

import Layout from "../components/Layout"
import News from "../components/News/News"
import Banner from "../components/Banner/Banner"
import Subscribe from "../components/Subscribe/Subscribe";
import LocationBlock from "../components/LocationBlock/LocationBlock";
import AreaGuide from "../components/AreaGuide/AreaGuide";
import ContentModule from "../modules/content_module";
import CTABtnModule from "../modules/cta_btn_module";
import _ from "lodash";

import { getOffset } from "../common/utils/site_utlis"
import BreadCrumbs from "../components/StaticBanner/BreadCrumbs";
import LocalExperience from "../components/LocalExperience/LocalExperience"
import Brands from "../components/Brands/Brands"
import FAQ from "../components/Faq/Faq"
import AllAgentReview from "../components/ClientReview/AllAgentReview";
import { IsAllAgentReview } from "../common/constant";
import LeadooScript from "../components/LeadooScript/LeadooScript";
import Customer from "../components/Customer/Customer";
import TilesBlock from "../components/TilesBlock/Tiles";
import ServiceTiles from "../components/TilesBlock/ServiceTiles";
import ManagementServices from "../components/ManagementServices/ManagementServices"

import PackageOption from "../components/PackageOption/PackageOption";
import ServiceOption from "../components/ServiceOption/ServiceOption";

import ImageTextCarousal from "../components/ImageTextCarousal/ImageTextCarousal"
import ServiceContentCard from "../components/ServiceContentCard/ServiceContentCard"
import Journey from "../components/Journey/Journey";
import WhyChoose from "../components/Counter/WhyChoose";
import Investments from "../components/Investments/Investments";
import StaticPageCalculator from "../components/StaticPageCalculator/StaticPageCalculator";
import Counter from "../components/Counter/Counter";

import {leadooPageSlot} from "../common/constant";

import {PageLinks} from "../common/page-links";

const StaticTemplate = (props) => {

  const[package_option, setPackageOption] = useState("");
  const[service_option, setSerivceOption] = useState([]);
  const[price_text, setPriceText] = useState([]);

  var GQLPage = props.GQLPage;
  var GQLModules = props.GQLModules;
  var sidebar = _.find(GQLModules, function (o) { return o.__typename === "GLSTRAPI_ComponentComponentsShowRightsideBar" });

  var isJourneySec = _.find(GQLModules, function (o) { return o.__typename === "GLSTRAPI_ComponentComponentsShowPropertyJourney" && o.show });

  let pathname = GQLPage?.menu?.slug ? GQLPage?.menu?.slug.replace(/-/g, '_') : "";

  //Sticky
  const stickyRef = useRef();
  const stickyRef2 = useRef();
  const [stickyCls, setStickyCls] = useState('');

  // useEffect(() => {

  //     window.addEventListener("scroll", windowScroll);
  //     return () => window.removeEventListener("scroll", windowScroll);

  // }, [])

  
  const windowScroll = () => {
      const top = getOffset(stickyRef.current)?.top;
      const top2 = getOffset(stickyRef2.current)?.top - 500;
      //const top =  $(".right-box")?.offset()?.top;
      //const bottomSticky = getOffset(stickyRef.current).top;
      // const top = 650;
      // const bottomSticky = 1500;

      //console.log("top ==>", $(".non_sticky")?.offset()?.top, window.pageYOffset, window.innerWidth, top);

      var left_side_div = $(".static-details")?.height();
      var right_side_div = $(".right_side_div")?.height();

      //console.log("right_side_div",left_side_div, right_side_div)

      //console.log("right_side_div", window.pageYOffset, top, top2)


        
      if(window.pageYOffset > top && window.pageYOffset < top2){
        setStickyCls('is-sticked');
        //$(".inner-wrap")?.removeClass("non_sticky")
      } else {
        setStickyCls('');
        //$(".inner-wrap")?.addClass("non_sticky")
      }

      //console.log("window", window.innerWidth)
  }
  // Sticky

  const proceedToPay = () => {
    localStorage.setItem('package_option', package_option)
    localStorage.setItem('service_option', JSON.stringify(service_option));

    navigate(`/${PageLinks.maintenance_payment}/`)
  }

  useEffect(() =>{

    var pricetext = [];
    if(package_option){
      pricetext.push(package_option)
    }
    if(service_option.length > 0){
      pricetext.push(service_option.join(', '))
    }

    //console.log("package_option 1", package_option, service_option)

    setTimeout(()=>{
      setPriceText(pricetext)
    },500)
    //setPriceText(pricetext)
    
  },[package_option, service_option])


  //console.log("package_option", package_option, service_option, price_text);


  return (
    <div className={`static-page ${GQLPage?.menu?.parent?.slug}`}>
      <Layout seo_meta={GQLPage.seo_meta} isJourneySec={isJourneySec} menu_slug={GQLPage?.menu?.slug} popular_search={GQLPage?.menu?.popular_search} GQLPage={GQLPage}>
        {GQLPage?.banner_section?.banner_image && <Banner banner_section={GQLPage.banner_section} GQLPage={GQLPage} />}
        

        {(GQLPage.content || sidebar) &&
          <section className="static-details">

            {GQLPage?.menu?.parent?.slug === "hardisty-prestige" && 
              <>
                <BreadCrumbs GQLPage={GQLPage}/>
                {GQLPage?.title && 
                <Container>
                  <Row>
                    <Col>
                        <h1>{GQLPage.title}</h1>
                    </Col>
                  </Row>
                </Container>
                }
              </>
            }

            <Container>
              <Row>
                <Col lg={sidebar ? 8 : 12}>
                  <div className="details-wrap">
                    <ContentModule Content={GQLPage.content} />

                    {GQLModules?.length > 0 && GQLModules?.filter(Module => Module.__typename ==="GLSTRAPI_ComponentComponentsFaq").map((Module, index) => {
                      return(
                        <FAQ key={Module} Module={Module} />
                      )
                     })
                    }
                  </div>
                </Col>
                {sidebar &&
                  <Col lg={4} ref={stickyRef} className="right_side_div">
                    <section className={`inner-wrap ${stickyCls}`}>
                      
                      {sidebar.button_cta &&
                        <section className="bottom-btn">
                          <Container>
                            <Row>
                              <Col>
                                <div className={`btn-wrapper`}>
                                <CTABtnModule button_cta={sidebar?.button_cta} />
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </section>
                      }

                      {sidebar.show_newsletter &&
                        <Subscribe />
                      }
                    </section>
                  </Col>
                }
              </Row>
            </Container>
          </section>
        }


        {GQLModules?.length > 0 && GQLModules?.map((Module, index) => {
          return (
            <div ref={stickyRef2}>
              {Module?.__typename === "GLSTRAPI_ComponentComponentsLeadooChatComponent" && <LeadooScript key={Module} Module={Module}/> }

              {Module.__typename === "GLSTRAPI_ComponentComponentsVideoSection" &&  <Customer key={Module} Module={Module} GQLPage={GQLPage}/>}

              {Module.__typename === "GLSTRAPI_ComponentComponentsLocalExperience" && <LocalExperience key={Module} Module={Module} GQLPage={GQLPage}/>}

              {Module.__typename === "GLSTRAPI_ComponentComponentsShowStatisticsSection" && Module.show &&  <Counter key={Module} Module={Module} pathname={pathname} leadooPageSlot={leadooPageSlot}/>}

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "offices" && <LocationBlock key={Module} Module={Module} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "area_guide" && <AreaGuide key={Module} Module={Module} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "brands" && <Brands key={Module} Module={Module} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsShowNewsInsight" && Module.show && <News key={Module} Module={Module} />}

              {Module?.__typename === "GLSTRAPI_ComponentComponentsTilesBoxComponent" && <TilesBlock key={Module} Module={Module} GQLPage={GQLPage} /> }

              {Module.__typename === "GLSTRAPI_ComponentComponentsImageTextCarousel" && <ImageTextCarousal key={Module} Module={Module} GQLPage={GQLPage}/> }

              {Module?.__typename === "GLSTRAPI_ComponentComponentsServiceTilesComponent" && <ServiceTiles key={Module} Module={Module} GQLPage={GQLPage} /> }

              {Module.__typename === "GLSTRAPI_ComponentComponentsPropertyServiceManagement" && <ManagementServices key={Module} Module={Module}/> }

              {Module.__typename === "GLSTRAPI_ComponentComponentsWhyChooseComponent" && <WhyChoose key={Module} Module={Module} /> }

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "reviews" && ( <>
                {IsAllAgentReview === true && <AllAgentReview Module={Module} />}
                </>
              )}

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "investments" && ( <>
                <Investments key={Module} Module={Module} />
                </>
              )}

              {Module.__typename === "GLSTRAPI_ComponentComponentsCalculatorComponent" && 
              <StaticPageCalculator key={Module} Module={Module} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsServiceContentCardComponent" && <ServiceContentCard key={Module} Module={Module} GQLPage={GQLPage}/> }

              {Module.__typename === "GLSTRAPI_ComponentComponentsPackageComponent" && <PackageOption key={Module} Module={Module} setPackageOption={setPackageOption} package_option={package_option}/> }

              {Module.__typename === "GLSTRAPI_ComponentComponentsServicesAvailableComponent" && <ServiceOption key={Module} Module={Module} setSerivceOption={setSerivceOption} service_option={service_option} /> }

              {Module.__typename ==="GLSTRAPI_ComponentComponentsFaq" && 
              <section className={`faq_section ${Module?.faq_bg}`} id="faqs">
                  <Container>
                      <Row>
                          <Col><FAQ key={Module} Module={Module} /></Col>
                      </Row>
                  </Container>
              </section>
              }

              {Module.__typename === "GLSTRAPI_ComponentComponentsShowPropertyJourney" && Module.show && <Journey key={Module} />}
              
            </div>
          )
        })}


        {(package_option || service_option?.length > 0) &&
          <div className="payment_info">
            <Container>
              <Row>
                  <Col>
                    <p>Click the below link to proceed with {price_text.length > 0 && <b>{price_text.join(' and ')}</b>} </p>
                    <a href="javscript:;" className='btn btn-primary' onClick={proceedToPay}>Proceed  to Pay</a>
                  </Col>
              </Row>
            </Container>
          </div>
        }

      </Layout>
    </div>
  )

}

export default StaticTemplate